import { main } from 'gleam:admin'
import * as config from '#admin/config'

// Setup the environment.
config.vercel.setup()
config.elements.register()

// Start the Lustre app.
document.addEventListener('DOMContentLoaded', main)
